import { __decorate, __metadata } from 'tslib';
import { Service } from '../../decorators/class/service.js';
import { ControllerRegistry } from '../../registries/controller-registry.js';
import { BuiltinUiState } from '../../services/store/builtin-state.js';
import { StateManager } from '../../services/store/state-manager.js';

/**
 * scope级别开关
 */
let ScopeToggle = class ScopeToggle {
    constructor(store) {
        this.store = store;
    }
    isDisabled(info) {
        var _a, _b, _c, _d;
        const disabledScopes = this.store.getValue(BuiltinUiState.ScopeStatus);
        let disableByScope = false;
        const registeredTarget = info.configController;
        const callbackTarget = info.callBackController;
        const registeredTargetCustomScope = (_b = ((_a = (registeredTarget
            && ControllerRegistry.get(registeredTarget))) === null || _a === void 0 ? void 0 : _a.customScope)) !== null && _b !== void 0 ? _b : [];
        const callbackTargetCustomScope = (_d = ((_c = (callbackTarget
            && ControllerRegistry.get(callbackTarget))) === null || _c === void 0 ? void 0 : _c.customScope)) !== null && _d !== void 0 ? _d : [];
        // 查询provider中scope是否被禁用
        const customScope = registeredTargetCustomScope.concat(callbackTargetCustomScope);
        customScope === null || customScope === void 0 ? void 0 : customScope.forEach((scope) => {
            if (disabledScopes === null || disabledScopes === void 0 ? void 0 : disabledScopes.has(scope)) {
                disableByScope = true;
            }
        });
        return disableByScope;
    }
};
ScopeToggle = __decorate([
    Service(),
    __metadata("design:paramtypes", [StateManager])
], ScopeToggle);

export { ScopeToggle };
//# sourceMappingURL=scope-toggle.js.map
